// extracted by mini-css-extract-plugin
export default {"tooltip":"BarChartDataTooltip_tooltip__OQfZm","colorBlock":"BarChartDataTooltip_colorBlock__jbi+E"};